import { NavLink, useLocation, useResolvedPath } from 'react-router-dom';
import { cn } from '../lib/cn.js';

export function SidebarItem({ to, icon, label, badge, tag, disabled = false, hint, onNavigate }) {
  const resolved = useResolvedPath(to);
  const location = useLocation();
  const isSameRoute = location.pathname === resolved.pathname;

  if (disabled) {
    return (
      <div
        className={cn('sb-item', 'opacity-60 cursor-not-allowed')}
        aria-disabled="true"
      >
        {icon && <span aria-hidden>{icon}</span>}
        <span>{label}</span>
        {tag && <span className="sb-tag">{tag}</span>}
        {hint && <span className="hint">{hint}</span>}
      </div>
    );
  }

  return (
    <NavLink
      to={to}
      onClick={(event) => {
        if (isSameRoute) {
          event.preventDefault();
          onNavigate?.();
          return;
        }
        onNavigate?.();
      }}
      className={({ isActive }) => cn('sb-item', isActive && 'is-active')}
    >
      {icon && <span aria-hidden>{icon}</span>}
      <span>{label}</span>
      {tag && <span className="sb-tag">{tag}</span>}
      {badge != null && <span className="badge">{badge}</span>}
    </NavLink>
  );
}
